import "./PrivacyPolicyAndPersonalData.module.css";
import Header from "@/reusable_sections/Header";
import OurPhilosophy from "./sections/OurPhilosophy";
import TheManifesto from "./sections/TheManifesto";
import OurRawPhilosophy from "./sections/OurRawPhilosophy";
import OurGuarantee from "./sections/OurGuarantee";
import Gdpr from "./sections/Gdpr";
import Cookies from "./sections/Cookies";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyAndPersonalDataPage() {
  return <div>
      <Header />
      <OurPhilosophy />
      <TheManifesto />
      <OurRawPhilosophy />
      <OurGuarantee />
      <Gdpr />
      <Cookies />
      <Contact />
      <Footer />
    </div>;
}